export const checkIfInLocalStorage = (productId: number) => {
  const storedFavorites =
    typeof localStorage === 'undefined'
      ? []
      : JSON.parse(localStorage.getItem('favoriteProducts') || '[]').map(Number);
  return storedFavorites.includes(productId); // Returns true if the product is in localStorage
};
